import Pusher from 'pusher-js'

const baseUrl = process.env.REACT_APP_SERVER_API_URL || 'https://api2dev.asiacommerce.net'
const isDev = Boolean(baseUrl === 'https://api2dev.asiacommerce.net')

const _credentialDev = {
  app_id: '1371489',
  key: 'baec0a4c23102b720836',
  secret: '1aa36bcfbd9b889353bc',
  cluster: 'ap1',
}
const _credentialProd = {
  app_id: '1371490',
  key: '12e54c52b27579ccf609',
  secret: '8ee5acc5024617e6da16',
  cluster: 'ap1',
}

const credential = {
  ...(isDev ? _credentialDev : _credentialProd),
}

const pusher = new Pusher(credential.key, {
  cluster: credential.cluster,
})


export const pusherSubscribe = (channelName) => {
  return pusher.subscribe(channelName)
}

export const pusherUnsubscribe = (channelName) => {
  pusher.unsubscribe(channelName)
}